import { Sparkles } from "lucide-react";
import { lerp, easeOut } from "./useFrame";

type Props = { frame: number };

/**
 * 17–20s: Final close. Big headline, founding-member badge, primary CTA.
 *
 * Local frame range: 1020..1200.
 */
export const SceneCta = ({ frame }: Props) => {
  const f = frame - 1020; // 0..180

  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-5 px-6 text-center">
      <span
        className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1 text-[11px] font-semibold tracking-wide text-primary ring-1 ring-primary/30"
        style={{
          opacity: easeOut(lerp(f, [0, 22], [0, 1])),
          transform: `scale(${lerp(f, [0, 22], [0.9, 1])})`,
        }}
      >
        <Sparkles className="h-3 w-3" />
        Founding Member offer
      </span>

      <h2
        className="font-display text-2xl font-semibold leading-tight text-foreground sm:text-3xl"
        style={{
          opacity: easeOut(lerp(f, [10, 36], [0, 1])),
          transform: `translateY(${lerp(f, [10, 36], [10, 0])}px)`,
        }}
      >
        Turn recipe chaos into a&nbsp;clean kitchen.
      </h2>

      <p
        className="max-w-md text-sm text-muted-foreground sm:text-base"
        style={{
          opacity: easeOut(lerp(f, [24, 50], [0, 1])),
        }}
      >
        Unlimited recipes, smart shopping, timers & PDF export — from £3/mo.
      </p>

      <div
        className="flex items-baseline gap-2"
        style={{
          opacity: easeOut(lerp(f, [40, 64], [0, 1])),
          transform: `translateY(${lerp(f, [40, 64], [8, 0])}px)`,
        }}
      >
        <span className="font-display text-3xl font-semibold text-foreground">£3</span>
        <span className="text-sm text-muted-foreground">/ month</span>
      </div>
    </div>
  );
};
